if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setupNav();
        this.showActiveMedia();
      }

      setupNav() {
        if (this.navReady) return;

        this.track = this.querySelector('[data-modal-track]');
        this.prevBtn = this.querySelector('[data-modal-prev]');
        this.nextBtn = this.querySelector('[data-modal-next]');
        this.counterCurrent = this.querySelector('[data-modal-counter-current]');
        this.slides = this.track ? Array.from(this.track.children) : [];

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.goTo(this.activeIndex() - 1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.goTo(this.activeIndex() + 1));
        }
        if (this.track) {
          this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        }

        this.navReady = true;
      }

      activeIndex() {
        return this.slides.findIndex((slide) => slide.classList.contains('active'));
      }

      goTo(index) {
        if (!this.slides.length) return;
        const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
        const target = this.slides[clamped];
        if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      onScroll() {
        if (!this.track) return;
        clearTimeout(this._scrollTimeout);
        this._scrollTimeout = setTimeout(() => {
          const trackRect = this.track.getBoundingClientRect();
          const center = trackRect.left + trackRect.width / 2;
          let closest = null;
          let closestDistance = Infinity;

          this.slides.forEach((slide) => {
            const rect = slide.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - center);
            if (distance < closestDistance) {
              closestDistance = distance;
              closest = slide;
            }
          });

          if (closest) this.setActive(closest);
        }, 100);
      }

      setActive(slideEl) {
        this.slides.forEach((slide) => slide.classList.remove('active'));
        slideEl.classList.add('active');

        const index = this.slides.indexOf(slideEl);
        if (this.counterCurrent) this.counterCurrent.textContent = index + 1;
        if (this.prevBtn) this.prevBtn.disabled = index <= 0;
        if (this.nextBtn) this.nextBtn.disabled = index >= this.slides.length - 1;

        const mediaEl = slideEl.querySelector('[data-media-id]');
        if (mediaEl && mediaEl.nodeName === 'DEFERRED-MEDIA') {
          const template = mediaEl.querySelector('template');
          const content = template ? template.content : null;
          if (content && content.querySelector('.js-youtube')) {
            mediaEl.loadContent();
          }
        }
      }

      showActiveMedia() {
        const openerMediaId = this.openedBy.getAttribute('data-media-id');
        const mediaEl = this.querySelector(`[data-media-id="${openerMediaId}"]`);
        const activeMedia = mediaEl ? mediaEl.closest('.product-media-modal__slide') : null;
        if (!activeMedia) return;

        this.setActive(activeMedia);
        activeMedia.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });

        const activeMediaTemplate = mediaEl.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          mediaEl.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          mediaEl.loadContent();
      }
    }
  );
}
